// extracted by mini-css-extract-plugin
export default {"toggle":"TagsSortToggle_toggle__McRue","option":"TagsSortToggle_option__dvh0A","active":"TagsSortToggle_active__w6fmW"};